import React from "react";
import PanelSupport from "../../UI/Support/PanelSupport";

const Support = () => {
  return <PanelSupport />;
};

export default React.memo(Support);
